import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'

import { auth } from './Modules/Auth'
import Product from './Modules/Product'
import User from './Modules/User'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        auth,
        Product,
        User,
    },
    getters,
})

export default store
